import React, { useEffect, useState } from "react";
import HTMLFlipBook from "react-pageflip";
import { useWindowSize } from "../Control/WindowSize";
import backImage from '../style/images/2.jpg'
const originalWidth = 954;
const originalHeight = 1349;
const Corparate = ({ props }) => {
    const { width, height } = useWindowSize()
    const downSize = 0.96
    const [isMobile, setIsMobile] = useState(false);
    const aspectRatio = originalWidth / originalHeight
    const [image, setImages] = useState([])
    const [bookDimesion, setBookDimesion] = useState({ width: 0, height: 0 })
    const onLoad = () => {
        var images = []
        const EndPage = 26;
        for (let index = 1; index <= 20; index++) {
            index < 10 ? images.push(`https://spiral.com.vn/corparate/cor-0${index}.jpg`)
                : images.push(`https://spiral.com.vn/corparate/cor-${index == 20 ? EndPage : index}.jpg`)
        }
        setImages(images)
    }
    useEffect(() => {
        const newIsMobile = width < 768;  // Thiết bị có chiều rộng dưới 768px là mobile
        if (newIsMobile) {//Di dong
            const newHeight = Math.min(height * downSize, height * aspectRatio * downSize);
            const newWidth = newHeight * aspectRatio;
            setBookDimesion({ width: newWidth, height: newHeight });
        } else {
            const newWidth = Math.min(width * downSize, height * aspectRatio * downSize);
            const newHeight = newWidth / aspectRatio;
            setBookDimesion({ width: newWidth, height: newHeight });
        }
        const _load = onLoad();
        setIsMobile(newIsMobile);
        return () => _load;
    }, [])

    return (
        <div style={{
            backgroundImage: `url(${backImage})`,
            backgroundSize: 'contain',
            display: 'flex',        // Bổ sung flexbox để căn giữa
            justifyContent: 'center', // Căn giữa theo chiều ngang
            alignItems: 'center',    // Căn giữa theo chiều dọc
            height: '100vh',         // Chiều cao của div bằng với toàn bộ chiều cao màn hình
            width: '100vw',      // Thêm width: 100vw để div rộng toàn bộ màn hình
            flex: 1,
            overflow: 'hidden'
        }}>
            {/* <div style={{ position: 'absolute', top: 10 }}>di dong - {isMobile + "a"} {bookDimesion.width} he {bookDimesion.height}</div> */}
            <HTMLFlipBook
                width={bookDimesion.width}
                height={bookDimesion.height}
                maxHeight={bookDimesion.height}
                maxWidth={bookDimesion.width}
                size={isMobile ? 'fixed' : "stretch"} // Điều chỉnh kích thước tự động
                showCover={true}
                drawShadow={true}
                autoSize={true}
                maxShadowOpacity={0.5}
                usePortrait={isMobile}   // Điều chỉnh cho chế độ portrait khi là mobile
                mobileScrollSupport={true}  // Hỗ trợ cuộn trên thiết bị di động
            >
                {image.map((imageSrc, index) => (
                    <div className="page" key={index}>
                        <img src={imageSrc} alt={`Page ${index + 1}`} />
                    </div>
                ))}
            </HTMLFlipBook>
        </div>
    );
};
export default Corparate;